<div class="mc-task-profile-dialog-details-container">
  <form [formGroup]="detailsFormGroup">
    <div class="mc-form-heading mc-task-profile-dialog-details-heading">
      General
      <span class="mc-fill-remaining-flex-space"></span>
      <div class="mc-task-profile-dialog-details-heading-icons">
        <mc-task-comment-icon [count]="task.TaskCommentCount" size="normal" [displayParenthesis]="false" [matTooltip]="'This task has ' + (task.TaskCommentCount | mcPluralize: 'comments-numeric')"></mc-task-comment-icon>
        &nbsp;
        &nbsp;
        <mc-task-asset-icon [count]="task.TaskAssetCount" size="normal" [displayParenthesis]="false" [matTooltip]="'This task has ' +  (task.TaskAssetCount | mcPluralize: 'attachments-numeric')"></mc-task-asset-icon>
      </div>
    </div>
    <div class="mc-form-fields-row">
      <mat-form-field class="mc-form-field" mcColor="secondary">
        <mat-label>Priority</mat-label>
        <mat-select [(value)]="task.TaskPriority" [disabled]="!canEditAllTasks">
          <mat-select-trigger>
            <div class="mc-task-profile-dialog-details-select-trigger-wrapper">
              <ng-container *ngIf="task.TaskPriority === TaskPriority.Low">
                <mat-icon color="task-low-priority" [fontSet]="'project-titan'" class="mc-task-profile-dialog-details-select-trigger-item" [fontIcon]="'icon-dot'"></mat-icon>
                Low Priority
              </ng-container>
              <ng-container *ngIf="task.TaskPriority === TaskPriority.Medium">
                <mat-icon color="task-medium-priority" [fontSet]="'project-titan'" class="mc-task-profile-dialog-details-select-trigger-item" [fontIcon]="'icon-dot'"></mat-icon>
                Medium Priority
              </ng-container>

              <ng-container *ngIf="task.TaskPriority === TaskPriority.High">
                <mat-icon color="task-high-priority" [fontSet]="'project-titan'" class="mc-task-profile-dialog-details-select-trigger-item" [fontIcon]="'icon-dot'"></mat-icon>
                High Priority
              </ng-container>
            </div>
          </mat-select-trigger>
          <mat-option [value]="TaskPriority.Low">
            <mat-icon color="task-low-priority" [fontSet]="'project-titan'" [fontIcon]="'icon-dot'"></mat-icon>
            Low Priority
          </mat-option>
          <mat-option [value]="TaskPriority.Medium">
            <mat-icon color="task-medium-priority" [fontSet]="'project-titan'" [fontIcon]="'icon-dot'"></mat-icon>
            Medium Priority
          </mat-option>
          <mat-option [value]="TaskPriority.High">
            <mat-icon color="task-high-priority" [fontSet]="'project-titan'" [fontIcon]="'icon-dot'"></mat-icon>
            High Priority
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mc-form-field" mcColor="secondary">
        <mat-label>Status</mat-label>
        <mat-select [value]="task.Status === TaskStatus.Active ? task.Milestone : task.Status" [disabled]="!canEditAllTasks" (selectionChange)="onStatusChanged($event)">
          <mat-option [value]="TaskMilestone.ToDo" [ngClass]="{'mat-selected': task.Status === TaskStatus.Active && task.Milestone === TaskMilestone.ToDo}">
            To Do
          </mat-option>
          <mat-option [value]="TaskMilestone.InProgress" [ngClass]="{'mat-selected': task.Status === TaskStatus.Active && task.Milestone === TaskMilestone.InProgress}">
            In Progress
          </mat-option>
          <mat-option [value]="TaskMilestone.Completed" [ngClass]="{'mat-selected': task.Status === TaskStatus.Active && task.Milestone === TaskMilestone.Completed}">
            Completed
          </mat-option>
          <mat-option [value]="TaskStatus.Backlog" [ngClass]="{'mat-selected': task.Status === TaskStatus.Backlog}">
            Backlog
          </mat-option>
          <mat-option [value]="TaskStatus.Archive" [ngClass]="{'mat-selected': task.Status === TaskStatus.Archive}">
            Archive
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mc-form-fields-row">
      <mat-form-field mcColor="secondary" class="mc-form-field" floatLabel="always">
        <mat-label>Start Date</mat-label>
        <input formControlName="start" matInput [matDatepicker]="startPicker" placeholder="--/--/----" (dateChange)="onStartDateValueChanged($event.value)">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker">
        </mat-datepicker-toggle>
        <mat-datepicker color="secondary" #startPicker></mat-datepicker>
        <mat-error *ngIf="detailsFormGroup.get('start').errors?.mismatch">Start Date is required</mat-error>
        <mat-error *ngIf="detailsFormGroup.get('start').errors?.overlap">Cannot set after Due</mat-error>
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Start Time</mat-label>
        <input matInput #startTime formControlName="startTime" type="time" placeholder="Start Time" (blur)="onStartTimeValueChanged(startTime.value)">
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field" floatLabel="always">
        <mat-label>Due Date</mat-label>
        <input formControlName="due" matInput [matDatepicker]="duePicker" placeholder="--/--/----" (dateChange)="onDueDateValueChanged($event.value)">
        <mat-datepicker-toggle matIconSuffix [for]="duePicker">
        </mat-datepicker-toggle>
        <mat-datepicker color="secondary" #duePicker></mat-datepicker>
        <mat-error *ngIf="detailsFormGroup.get('due').errors?.mismatch">Due Date is required</mat-error>
        <mat-error *ngIf="detailsFormGroup.get('due').errors?.overlap">Cannot set before Start</mat-error>
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Due Time</mat-label>
        <input matInput #dueTime type="time" formControlName="dueTime" placeholder="Due Time" (blur)="onDueTimeValueChanged(dueTime.value)">
      </mat-form-field>
    </div>
    <mat-checkbox class="text-small" [checked]="task.AllDay" (change)="onAllDayChecked($event.checked)" [disabled]="!canEditAllTasks" color="accent-vivid">
      All Day Event
    </mat-checkbox>

    <div class="mc-form-fields-row">
      <mat-form-field mcColor="secondary" class="mc-form-field">
        <mat-label>Task Board</mat-label>
        <mat-select formControlName="taskBoard" (selectionChange)="task.TaskBoardId = $event.value">
          <mat-option *ngFor="let tb of taskBoards" [value]="tb.Id">{{tb.Title}}</mat-option>
        </mat-select>
        <mat-error *ngIf="detailsFormGroup.get('taskBoard').errors?.required">Task Board is required</mat-error>
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field mc-task-profile-dialog-details-task-estimates-form-field">
        <mat-label>Estimated Hours</mat-label>
        <input class="text-small" formControlName="estHour" matInput type="number" (change)="task.EstHour=+$event.target.value" min="0">
        <mat-error *ngIf="detailsFormGroup.get('estHour').errors?.undefined">Estimated hours is required</mat-error>
        <mat-error *ngIf="detailsFormGroup.get('estHour').errors?.invalidNegative">Must be greater than or equal to zero</mat-error>
        <mat-error *ngIf="detailsFormGroup.get('estHour').errors?.invalidMax">Must be less than 1000</mat-error>
      </mat-form-field>
      <mat-form-field mcColor="secondary" class="mc-form-field mc-task-profile-dialog-details-task-estimates-form-field">
        <mat-label>Position</mat-label>
        <input class="text-small" formControlName="position" matInput type="number" (change)="task.Position=(+$event.target.value)-1" min="1">
        <mat-error *ngIf="detailsFormGroup.get('position').errors?.undefined">Position is required</mat-error>
        <mat-error *ngIf="detailsFormGroup.get('position').errors?.invalidNegative">Must be greater than zero</mat-error>
        <mat-error *ngIf="detailsFormGroup.get('position').errors?.invalidMax">Position must be less than {{maxPosition+1}}</mat-error>
      </mat-form-field>
    </div>


    <div class="mc-task-profile-dialog-details-avatars-wrapper">
      <!-- Owner -->
      <div class="mc-task-profile-dialog-details-avatar-container"> <!-- This class is not used just for grid to work -->
        <b class="mc-task-profile-dialog-details-avatar-header">Owner</b>
        <div class="mc-task-profile-dialog-details-avatar-wrapper">
          <mc-license-user-avatar [licenseUser]=" createdByUser$ | async" size="small" [disabledName]="true" [truncate]="true"></mc-license-user-avatar>
          &nbsp;
          <button *ngIf="canEditAllTasks && task.CreatedByUserId" type="button" class="mc-button-small mc-task-profile-dialog-details-add-button" mat-icon-button color="accent-vivid" [matMenuTriggerFor]="ownerMenu">
            <mat-icon [fontSet]="'project-titan'" color="secondary" [fontIcon]="'icon-expand'"></mat-icon>
          </button>
        </div>
      </div>
      <!-- /Owner -->

      <!--Assigned -->
      <div class="mc-task-profile-dialog-details-avatar-container"> <!-- This class is not used just for grid to work -->
        <b class="mc-task-profile-dialog-details-avatar-header">Assigned</b>
        <div class="mc-task-profile-dialog-details-avatar-wrapper">
          <mc-license-user-avatar *ngIf="task.AssignedUserId; else addUser" [licenseUser]="assignedUser$ | async" size="small" [disabledName]="true" [truncate]="true"></mc-license-user-avatar>
          &nbsp;
          <button *ngIf="canEditAllTasks && task.AssignedUserId" type="button" class="mc-button-small mc-task-profile-dialog-details-add-button" mat-icon-button color="accent-vivid" [matMenuTriggerFor]="userMenu">
            <mat-icon [fontSet]="'project-titan'" color="secondary" [fontIcon]="'icon-expand'"></mat-icon>
          </button>
          <ng-template #addUser>
            <button *ngIf="canEditAllTasks" type="button" class="mc-task-profile-dialog-details-add-project-or-user-button" mat-icon-button color="secondary" [matMenuTriggerFor]="userMenu" [disabled]="!canEditAllTasks">
              <mat-icon class="mc-task-profile-dialog-details-project-add-folder-or-user-icon" [fontSet]="'project-titan'" [fontIcon]="'icon-user'"></mat-icon>
            </button>
          </ng-template>
        </div>
      </div>
      <!--/Assigned -->

      <!-- Project -->
      <div class="mc-task-profile-dialog-details-avatar-container">
        <b class="mc-task-profile-dialog-details-avatar-header">Project</b>
        <div class="mc-task-profile-dialog-details-avatar-wrapper">
          <mc-project-avatar *ngIf="task.ProjectId; else addProject" [disabledName]="true" size="small" [project]="project$ | async" size="small" [truncate]="true">
          </mc-project-avatar>
          &nbsp;
          <button *ngIf="canEditAllTasks && task.ProjectId" class="mc-button-small" mat-icon-button type="button" color="accent-vivid" [matMenuTriggerFor]="projectMenu">
            <mat-icon [fontSet]="'project-titan'" color="secondary" class="mc-task-profile-dialog-details-edit-icon" [fontIcon]="'icon-expand'"></mat-icon>
          </button>
          <ng-template #addProject>
            <!-- Icon within icon button -->
            <button *ngIf="canEditAllTasks" class="mc-task-profile-dialog-details-add-project-or-user-button" type="button" mat-icon-button color="secondary" [matMenuTriggerFor]="projectMenu">
              <mat-icon [fontSet]="'project-titan'" [fontIcon]="'icon-folder'"></mat-icon>
              <mat-icon [fontSet]="'project-titan'" [fontIcon]="'icon-expand'" class="mc-task-profile-dialog-details-project-add-icon"></mat-icon>
            </button>
          </ng-template>
        </div>
      </div>
      <!-- /Project -->
    </div>
  </form>
  <h4 class="mc-form-heading">Description</h4>
  <mc-rich-text-editor *ngIf="canEditAllTasks" [content]="task.Description" (editorStateChange)="onEditorStateChange()"></mc-rich-text-editor>
  <mc-rich-text-block *ngIf="!canEditAllTasks" [content]="task.Description" [showBorder]="true"></mc-rich-text-block>
</div>

<mat-menu class="mc-menu" #projectMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="onProjectClicked()">None</button>
  <button *ngFor="let project of projects" mat-menu-item (click)="onProjectClicked(project)">{{project.Name}}</button>
</mat-menu>
<mat-menu class="mc-menu" #ownerMenu="matMenu" [overlapTrigger]="false">
  <button *ngFor="let licenseUser of licenseUsers" mat-menu-item (click)="onLicenseUserClicked(false, licenseUser)">{{licenseUser.User.FullName}}</button>
</mat-menu>
<mat-menu class="mc-menu" #userMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="onLicenseUserClicked(true)">None</button>
  <button *ngFor="let licenseUser of licenseUsers" mat-menu-item (click)="onLicenseUserClicked(true, licenseUser)">{{licenseUser.User.FullName}}</button>
</mat-menu>